import { LMSTrainingMaterialDto, LMSTrainingStatus } from "../../settings/scripts/trainings.objects";

export { LMSTrainingStatus };

export class LMSUserTrainingOverviewDto {
    id: number;
    trainingName: string;
    instructions: string;
    daysRemaining: number;
    expirationDate: string;
    completedAt: string;
    isComplete: boolean;
    requiresUpload: boolean;
    materials: LMSTrainingMaterialDto[];

    getStatus(): LMSTrainingStatus {
        if (this.isComplete) {
            return this.hasExpired() ? "expired" : "complete";
        }

        return this.daysRemaining < 0 ? "overdue" : "pending";
    }

    private hasExpired(): boolean {
        if (!this.expirationDate) {
            return false;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return new Date(this.expirationDate) < today;
    }
}
